// extracted by mini-css-extract-plugin
module.exports = {"Login":"login_Login__1Rit3"};